export enum AppStyle {
    Mobile,
    Website,
    Formada
}
